/* eslint-disable react/function-component-definition */
import { Button } from '@mui/material';

import React from 'react';

export const ReplaceButton = () => {
  return (
    <Button
      sx={{
        textTransform: 'none',
        position: 'absolute',
        top: '50%',
        left: '30%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
      }}
      variant='contained'
      component='span'
      className='bg-gray-400 text-xs font-bold'
    >
      Replace
    </Button>
  );
};

export const AddButton = () => {
  return (
    <Button
      sx={{
        textTransform: 'none',
        position: 'absolute',
        top: '50%',
        left: '30%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
        width: '90px',
      }}
      variant='contained'
      component='span'
      className='bg-gray-400 text-xs font-bold'
    >
      Add
    </Button>
  );
};

export const UploadButton = () => {
  return (
    <Button
      sx={{
        textTransform: 'none',
        position: 'absolute',
        top: '50%',
        left: '30%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
      }}
      variant='contained'
      component='span'
      className='bg-gray-400 text-xs font-bold'
    >
      Upload
    </Button>
  );
};

export const ViewButton = ({ onClick }) => {
  return (
    <Button
      variant='contained'
      size='small'
      sx={{
        textTransform: 'none',
        backgroundColor: '#E0F2FE',
        color: '#0369A1',
        borderRadius: '8px',
        px: 2,
        fontWeight: 600,
        '&:hover': { backgroundColor: '#BAE6FD' },
      }}
      onClick={onClick}
    >
      View
    </Button>
  );
};

export const DeleteButton = ({ onClick, disabled }) => {
  return (
    <Button
      variant='contained'
      size='small'
      sx={{
        textTransform: 'none',
        backgroundColor: '#FEE2E2',
        color: '#B91C1C',
        borderRadius: '8px',
        px: 2,
        fontWeight: 600,
        '&:hover': { backgroundColor: '#FECACA' },
      }}
      onClick={onClick}
      disabled={disabled}
    >
      Delete
    </Button>
  );
};

export const InclusionButton = ({ onClick }) => {
  return (
    <Button
      variant='contained'
      size='small'
      sx={{
        textTransform: 'none',
        backgroundColor: '#FEE2E2',
        color: '#B91C1C',
        borderRadius: '8px',
        px: 2,
        fontWeight: 600,
        '&:hover': { backgroundColor: '#FECACA' },
      }}
      onClick={onClick}
    >
      Remove from Inclusion
    </Button>
  );
};

export const ExclusionButton = ({ onClick }) => {
  return (
    <Button
      variant='contained'
      size='small'
      sx={{
        textTransform: 'none',
        backgroundColor: '#FEE2E2',
        color: '#B91C1C',
        borderRadius: '8px',
        px: 2,
        fontWeight: 600,
        '&:hover': { backgroundColor: '#FECACA' },
      }}
      onClick={onClick}
    >
      Remove from Exclusion
    </Button>
  );
};

export const EditButton = ({ onClick, disabled }) => {
  return (
    <Button
      variant='contained'
      size='small'
      sx={{
        textTransform: 'none',
        backgroundColor: '#F3E8FF',
        color: '#6B21A8',
        borderRadius: '8px',
        px: 2,
        fontWeight: 600,
        '&:hover': { backgroundColor: '#E9D5FF' },
      }}
      onClick={onClick}
      disabled={disabled}
    >
      Edit
    </Button>
  );
};

export const DuplicateButton = ({ onClick }) => {
  return (
    <Button
      variant='contained'
      size='small'
      sx={{
        textTransform: 'none',
        backgroundColor: '#F3E8FF',
        color: '#6B21A8',
        borderRadius: '8px',
        px: 2,
        fontWeight: 600,
        '&:hover': { backgroundColor: '#E9D5FF' },
      }}
      onClick={onClick}
    >
      Duplicate
    </Button>
  );
};

export const CopyButton = ({ onClick }) => {
  return (
    <Button
      variant='contained'
      size='small'
      sx={{
        textTransform: 'none',
        backgroundColor: '#F3E8FF',
        color: '#6B21A8',
        borderRadius: '8px',
        px: 2,
        fontWeight: 600,
        '&:hover': { backgroundColor: '#E9D5FF' },
      }}
      onClick={onClick}
    >
      Copy Link
    </Button>
  );
};

export const ChangeButton = ({ onClick }) => {
  return (
    <Button
      variant='contained'
      size='small'
      sx={{
        textTransform: 'none',
        backgroundColor: '#F3E8FF',
        color: '#6B21A8',
        borderRadius: '8px',
        px: 2,
        fontWeight: 600,
        '&:hover': { backgroundColor: '#E9D5FF' },
      }}
      onClick={onClick}
    >
      Change
    </Button>
  );
};
